<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-form id="filterForm" validated novalidate>
          <b-card no-body>
            <b-card-body>
              <template>
                <b-row>
                  <b-col sm="2">
                    <b-form-group label-for="warehouse" label="Gudang">
                      <model-select
                        id="warehouse"
                        :options="listWarehouse"
                        v-model="warehouseId"
                        placeholder="Gudang"
                      ></model-select>
                      <b-form-invalid-feedback>Gudang harus di pilih.</b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
              </template>
            </b-card-body>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-row>
       <b-col lg="12">
          <history-detail :key="warehouseId" :warehouse-id="warehouseId"></history-detail>
       </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
import HistoryDetail from "./history/HistoryDetail.vue";

export default {
  name: "warehouse-hostory",
  components: { globalTable, ModelSelect, MultiSelect, loading, HistoryDetail },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listWarehouse: [],
      warehouseId: "1"
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
   
  },
  computed: {
    // warehouseId: function() {
    //   let route = this.$route.path.split("/");
    //   return route[4];
    // }
  },
  methods: {
    init: function(id) {
      this.loading = true;
      this.getWarehouse();
    },
    getWarehouse: function() {
      this.axios
        .get("web/dropdown/warehouse-history/")
        .then(response => {
          this.listWarehouse = response.data.warehouse;
        })
        .catch(error => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getHistoryWarehouse: function(event) {
      this.warehouseId=event;
      console.log(event);
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init(this.warehouseId);
  }
};
</script>

<style>
</style>
